import React from "react";
import CircleAlertFill from "../../icons/CircleAlert_Fill";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ActivationFailure = () =>
{
    const { t } = useTranslation();
    const { uiTheme, activationFailureErrorMsg } = useSelector((state) => state.activation)
    return (
        <div className="pagination-view">
            <div className="row text-body">
                <div className="display-flex">
                    <span style={{ height: 30, width: 30 }}><CircleAlertFill fill={uiTheme.buttonColour} /></span>
                    <div className="mar-none">
                        <b className="mar-none">{t('activationErrorScreen.error')}</b>
                        <span className="mar-none">&nbsp;{activationFailureErrorMsg}</span>
                        <p className="margin-tp-16">{t('activationErrorScreen.contactAdmin')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivationFailure;
